import React, {Component} from 'react'
import {connect} from 'react-redux'
import Loading from 'components/UI/Loading';
import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import {fetchAnnouncementList} from './redux/actions/getAnnouncementList'
import {deleteAnnouncement} from './redux/actions/deleteAnnouncement'
import {updateAnnouncement} from './redux/actions/updateAnnouncement'
import AnnouncementCard from './AnnouncementCard'
import Pagination from "react-js-pagination";

import './Announcement.scss'

const itemsCountPerPage = 12;

const mapStateToProps = (state) => ({
  user: state.user,
  announcementList: state.announcementList,
  currentTabState: state.announcementList.currentTabState
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAnnouncementList: (schoolId, param, amount_per_page, page_number,state, order_by, title_keyword) => dispatch(fetchAnnouncementList(schoolId, param, amount_per_page, page_number, state, order_by, title_keyword)),
    deleteAnnouncement: (announcementId, currentTabState) => dispatch(deleteAnnouncement(announcementId, currentTabState)),
    updateAnnouncement: (announcementId, announcementInfo, currentTabState) => dispatch(updateAnnouncement(announcementId, announcementInfo, currentTabState)),
  }
}


class DefaultTab extends Component {
  constructor(props){
    super(props)

    this.state = {
      activePage: 1
    }

    this.handlePageChange = this.handlePageChange.bind(this)
  }

  componentWillMount(){
    const {announcementState, orderBy, keyword} = this.props
    const {activePage} = this.state
    const schoolId = localStorage.getItem('schoolId')
    if(announcementState == 'all'){
      this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: activePage, order_by: orderBy, title_keyword: keyword})
    } else {
      this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: activePage, state: announcementState, order_by: orderBy, title_keyword: keyword})
    }
  }

  handlePageChange(pageNumber){
    const {announcementState, orderBy, keyword} = this.props
    const schoolId = localStorage.getItem('schoolId')

    this.setState({activePage: pageNumber});
    if(announcementState == 'all'){
      this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: pageNumber, order_by: orderBy, title_keyword: keyword})
    } else {
      this.props.fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: itemsCountPerPage, page_number: pageNumber, state: announcementState, order_by: orderBy, title_keyword: keyword})
    }

  }

  render(){
    const {announcementList, announcementState} = this.props;
    const {list, fetching, count, hasPermission, school_has_announcement} = announcementList;
    const content = onBoardingContents[announcementState];
    const {activePage} = this.state;

    if(fetching){
      return(
        <Loading />
      )
    }

    if((school_has_announcement == false && content) || !hasPermission){
      return(
        <OnBoardingNatural isShown={true} title={content.title} text={content.text} image={content.image} showArrow={content.showArrow} />
      )
    } else {
      return(
        <div>
          <div className='row announcement-card-container'>
            {list.map((announcement, index) => {
              return(
                <AnnouncementCard
                  key={index}
                  data={announcement}
                  deleteAnnouncement={(announcementId) => {
                    this.props.deleteAnnouncement(announcementId, this.props.currentTabState)
                  }}
                  updateAnnouncement={(announcementId, announcementInfo)=>{
                    this.props.updateAnnouncement(announcementId, announcementInfo, this.props.currentTabState)
                  }}
                  announcementState={announcementState}
                />
              )
            })}
          </div>
          <Pagination
            innerClass='pagination pull-right'
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={count}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange}
          />
        </div>
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultTab)



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/DefaultTab.js